import * as clone from 'clone'
import { StepType } from '@pushly/models/lib/enums/journeys'
import type { IJourneyStep, ITriggerStep } from '@pushly/models/lib/structs/journeys'
import { generateShortID } from './uid'
import { TriggerType, CatalogItemType } from '@pushly/models/lib/enums'
import type { Journey } from '../features/journeys/types/journey-api-response'

export const extractJourneyTrigger = (journey: Journey): ITriggerStep | undefined => {
    const steps = journey.revision?.steps
    if (!steps) return undefined
    return steps.find((s): s is ITriggerStep => s.type === StepType.TRIGGER)
}

export function isTriggerTypeOf(trigger: TriggerType, types: TriggerType | TriggerType[]): boolean {
    types = Array.isArray(types) ? types : [types]
    return types.includes(trigger)
}

export function reassignStepIds(steps: IJourneyStep[]): IJourneyStep[] {
    const reassigned = clone(steps)
    const updatedIdMap: any = {}

    reassigned.forEach((s) => {
        const newId = generateShortID()
        updatedIdMap[s.id] = newId
        s.id = newId
    })

    reassigned.forEach((s) => {
        if (!!s.configuration?.out_step_id) {
            s.configuration.out_step_id = updatedIdMap[s.configuration.out_step_id]
        }
    })

    return reassigned
}

export const getJourneyTriggerItemType = (journey: Journey): CatalogItemType | undefined => {
    return extractJourneyTrigger(journey)?.configuration?.params?.item_type
}
